var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-view"},_vm._l((_vm.columns),function(el){return _c('TimeList',{key:el._id,attrs:{"itemID":el._id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }